import styled from "styled-components";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.padding.container};
  margin: 0;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: ${({ theme }) => theme.shadow.large};
  flex: 1;
  width: 100%;
  height: 100%;

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.medium};
  }
`;

export const StyledContainerXScroll = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.padding.container};
  margin: 0;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: ${({ theme }) => theme.shadow.large};
  flex: 1;
  width: 100%;
  height: 100%;
  overflow-x: auto;

  @media (max-width: 1300px) {
    min-height: 400px;
  }

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.medium};
  }
`;
